import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { createContext, useEffect } from 'react'
import { trackPageView } from './utils/analytics'
import Home from './pages/Home'
import Pricing from './pages/Pricing'
import Upload from './pages/Upload'
import Download from './pages/Download'
import AdminLogin from './pages/admin/AdminLogin'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminSubmissions from './pages/admin/AdminSubmissions'
import AdminSubmissionDetails from './pages/admin/AdminSubmissionDetails'
import AdminOrders from './pages/admin/AdminOrders'
import AdminOrderDetails from './pages/admin/AdminOrderDetails'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/admin/ProtectedRoute'
import { AdminAuthProvider } from './contexts/AdminAuthContext'
import { ToastContainer } from './components/ui/Toast'
import { useToast } from './hooks/useToast'
import { ROUTES } from './config/constants'
import { Analytics } from '@vercel/analytics/react'

export const ToastContext = createContext(null)

function AppContent() {
  const toast = useToast()
  const location = useLocation()

  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname + location.search)
  }, [location])

  return (
    <ToastContext.Provider value={toast}>
      <AdminAuthProvider>
        <div className="min-h-screen bg-stadium-black">
          <Routes>
            {/* Public Routes */}
            <Route path={ROUTES.HOME} element={
              <>
                <Navbar />
                <Home />
                <Footer />
              </>
            } />
            <Route path={ROUTES.PRICING} element={
              <>
                <Navbar />
                <Pricing />
                <Footer />
              </>
            } />
            <Route path={ROUTES.UPLOAD} element={
              <>
                <Navbar />
                <Upload />
                <Footer />
              </>
            } />
            <Route path={ROUTES.DOWNLOAD} element={
              <>
                <Navbar />
                <Download />
                <Footer />
              </>
            } />
            
            {/* Admin Routes */}
            <Route path={ROUTES.ADMIN_LOGIN} element={<AdminLogin />} />
            <Route path={ROUTES.ADMIN_DASHBOARD} element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path={ROUTES.ADMIN_SUBMISSIONS} element={
              <ProtectedRoute>
                <AdminSubmissions />
              </ProtectedRoute>
            } />
            <Route path="/admin/submissions/:id" element={
              <ProtectedRoute>
                <AdminSubmissionDetails />
              </ProtectedRoute>
            } />
            <Route path={ROUTES.ADMIN_ORDERS} element={
              <ProtectedRoute>
                <AdminOrders />
              </ProtectedRoute>
            } />
            <Route path="/admin/orders/:id" element={
              <ProtectedRoute>
                <AdminOrderDetails />
              </ProtectedRoute>
            } />
          </Routes>
          <ToastContainer toasts={toast.toasts} onRemove={toast.removeToast} />
        </div>
      </AdminAuthProvider>
    </ToastContext.Provider>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <AppContent />
        <Analytics />
      </Router>
    </ErrorBoundary>
  )
}

export default App
